import { ONE_MINUTE } from "./duration"

const addMinutes = ({ currDate, mins }: { currDate: Date, mins: number }): Date => {
  return new Date(currDate.getTime() + mins * ONE_MINUTE)
}

export { addMinutes }